const CASH_SALE_MODAL_SELECTOR = ".cash-sale-modal";
const CASH_SALE_ROW_CLASS = "cash-sale-modal__row";
const CASH_SALE_ACTIONS_CLASS = "cash-sale-modal__actions";
const CASH_SALE_PRIMARY_CLASS = "cash-sale-modal__primary";
const CASH_CHANGE_HANDOFF_ATTRIBUTE = "data-cash-change-handoff";

function directChildWithClass(parent: HTMLElement, className: string) {
  return Array.from(parent.children).find(
    (child): child is HTMLElement => child instanceof HTMLElement && child.classList.contains(className),
  ) ?? null;
}

function refreshCashChangeHandoffPresentation() {
  const modals = document.querySelectorAll<HTMLElement>(CASH_SALE_MODAL_SELECTOR);

  modals.forEach((modal) => {
    const amountRow = directChildWithClass(modal, CASH_SALE_ROW_CLASS);
    const actions = directChildWithClass(modal, CASH_SALE_ACTIONS_CLASS);
    const actionChildren = actions ? Array.from(actions.children) : [];
    const onlyAction = actionChildren.length === 1 && actionChildren[0] instanceof HTMLElement
      ? actionChildren[0]
      : null;
    const committedCashHandoff = Boolean(
      amountRow
        && onlyAction
        && onlyAction.classList.contains(CASH_SALE_PRIMARY_CLASS),
    );

    if (committedCashHandoff) {
      modal.setAttribute(CASH_CHANGE_HANDOFF_ATTRIBUTE, "true");
    } else {
      modal.removeAttribute(CASH_CHANGE_HANDOFF_ATTRIBUTE);
    }
  });
}

/**
 * Presentation-only adapter for the existing CashSaleRuntimeHost DOM contract.
 *
 * A committed positive cash sale is the only current checkout state that renders
 * the direct received/change row together with a single primary "next sale"
 * action. The adapter marks that already-rendered surface so legacy Chromium
 * targets can receive the change-handoff hierarchy without relying on CSS :has().
 * No payment facts are read or recalculated here.
 */
export function registerCashChangeHandoffPresentation() {
  if (typeof document === "undefined" || !document.body || typeof MutationObserver === "undefined") {
    return () => undefined;
  }

  const observer = new MutationObserver(refreshCashChangeHandoffPresentation);
  observer.observe(document.body, { childList: true, subtree: true });
  refreshCashChangeHandoffPresentation();

  return () => {
    observer.disconnect();
    document.querySelectorAll<HTMLElement>(CASH_SALE_MODAL_SELECTOR).forEach((modal) => {
      modal.removeAttribute(CASH_CHANGE_HANDOFF_ATTRIBUTE);
    });
  };
}
